import { storyblokDataAttributes } from "@commerce-frontend/storyblok-preview/component";
import { CategoryIcon } from "@commerce-frontend/ui/base/CategoryIcon/CategoryIcon";
import { Icon } from "@commerce-frontend/ui/base/Icon/Icon";
import { Link } from "@commerce-frontend/ui/base/Link/Link";
import { cn } from "@commerce-frontend/ui/utils/classNames";
import { createCategoryCrumbsHash } from "@commerce-shared/url";
import { isValue } from "@commerce-shared/utility";
import type { FragmentOf } from "gql.tada";
import type { MenuItemFragment } from "../Header.fragments";

type Props = {
	menuItem: FragmentOf<typeof MenuItemFragment>;
};

export const SubNavigation = ({ menuItem }: Props) => (
	<div
		className="col-main columns-[4_13rem] gap-x-[clamp(1rem,-2.261rem+4.35vw,2rem)] text-base"
		aria-label="Sub Menu"
	>
		{menuItem.subMenuItems?.filter(isValue).map((subMenuItem, i) => (
			<ul
				key={subMenuItem.label}
				className={cn(
					"p-0",
					subMenuItem.subMenuLinks &&
						subMenuItem.subMenuLinks.length < 12 &&
						"break-inside-avoid",
				)}
				{...storyblokDataAttributes(subMenuItem)}
			>
				{subMenuItem.subMenuLinks ? (
					<>
						<li className={cn(i > 0 && "mt-4")}>
							<Link
								href={{
									pathname: subMenuItem.link.url,
									query: subMenuItem.alternativeCrumbs
										? {
												cr: createCategoryCrumbsHash(
													subMenuItem.alternativeCrumbs,
												),
											}
										: undefined,
								}}
								rel={subMenuItem.alternativeCrumbs ? "nofollow" : undefined}
								className="inline-flex items-center gap-1 font-bold hover:underline"
							>
								{subMenuItem.icon && (
									<CategoryIcon iconName={subMenuItem.icon} iconSize={"24"} />
								)}
								<span>{subMenuItem.label}</span>
								<Icon icon="chevron-right" />
							</Link>
						</li>

						{subMenuItem.subMenuLinks.filter(isValue).map((subMenuLink, i) => (
							<li
								key={subMenuLink.label}
								{...storyblokDataAttributes(subMenuLink)}
								className={cn("text-sm", i === 0 && "mt-1")}
							>
								<Link
									href={{
										pathname: subMenuLink.link.url,
										query: subMenuLink.alternativeCrumbs
											? {
													cr: createCategoryCrumbsHash(
														subMenuLink.alternativeCrumbs,
													),
												}
											: undefined,
									}}
									rel={subMenuLink.alternativeCrumbs ? "nofollow" : undefined}
									className="text-blue-300 hover:text-main hover:underline"
								>
									{subMenuLink.label}
								</Link>
							</li>
						))}
					</>
				) : (
					<li
						className={cn("flex items-center gap-1 font-bold", i > 0 && "mt-4")}
					>
						<Link
							href={{
								pathname: subMenuItem.link.url,
								query: subMenuItem.alternativeCrumbs
									? {
											cr: createCategoryCrumbsHash(
												subMenuItem.alternativeCrumbs,
											),
										}
									: undefined,
							}}
							rel={subMenuItem.alternativeCrumbs ? "nofollow" : undefined}
							className="inline-flex items-center"
						>
							{subMenuItem.icon && (
								<CategoryIcon iconName={subMenuItem.icon} iconSize={"24"} />
							)}
							{subMenuItem.label}
						</Link>
					</li>
				)}
			</ul>
		))}
	</div>
);
